// AI-CONTEXT: See docs/database.md (ProjectNotes)
// De notitiekolom in het projectenoverzicht en op de dashboardkaart 'Projecten
// met ster': per project de nieuwste notitie en het aantal. Dezelfde notities
// als het tabblad 'Notities' op de projectpagina (ProjectNotes.jsx), dus ook die
// binnen een taak geschreven zijn.

/**
 * @typedef {object} ProjectNoteSummary
 * @property {object} latest - De nieuwste notitie van het project
 * @property {number} count - Het aantal notities van het project
 */

/**
 * Een notitie zonder tijdstempel is net opgeslagen (serverTimestamp() staat
 * vlak na het schrijven nog op null) en is dus de nieuwste.
 * @param {{Timestamp?: {toMillis?: () => number}}} note
 * @returns {number}
 */
const sortKey = (note) => (typeof note?.Timestamp?.toMillis === 'function' ? note.Timestamp.toMillis() : Infinity)

/**
 * @param {Array<{ProjectID?: string}>} [notes] - ProjectNotes van deze omgeving (al zonder verwijderde)
 * @returns {Map<string, ProjectNoteSummary>} Per ProjectID
 */
const summarizeProjectNotes = (notes) => {
    const map = new Map()
    for (const note of Array.isArray(notes) ? notes : []) {
        if (!note?.ProjectID) continue
        const huidig = map.get(note.ProjectID)
        if (!huidig) {
            map.set(note.ProjectID, { latest: note, count: 1 })
            continue
        }
        huidig.count += 1
        if (sortKey(note) > sortKey(huidig.latest)) huidig.latest = note
    }
    return map
}

export default summarizeProjectNotes
